import { chunk } from 'lodash'
import { where } from 'firebase/firestore'

import FirestoreService from '../../firestoreService'
import { getConvertedData } from '../../../models/interface.helper'

import { RegistrationByDayModel } from '../../../models/registrations-by-day/registrationByDay.model'
import { IRegistrationByDayInterface } from '../../../models/registrations-by-day/registrationByDay.interface'

import { CONST } from '../../../const/const'

const COLLECTIONS = CONST.DATA.FIRESTORE.LATEST.COLLECTIONS

export const getById = async (id: string) => {
  try {
    const registrationsByDaySnapShot = await FirestoreService.getItem(
      COLLECTIONS.REGISTRATION_BY_DAY.NAME,
      id
    )

    return RegistrationByDayModel.fromFirestoreDoc(registrationsByDaySnapShot).toObject()
  } catch (error) {
    console.error(error, 'error')
  }
}

export const getByEventIds = async (eventIds: string[]) => {
  try {
    const registeredRiders: IRegistrationByDayInterface[] = []

    const chunks = chunk(eventIds, 30) // Firestore limits the 'in' clause to 30 items

    const snapPromises = chunks.map((chunkIds) =>
      FirestoreService.filterItems(COLLECTIONS.REGISTRATION_BY_DAY.NAME, [
        where(COLLECTIONS.REGISTRATION_BY_DAY.FIELDS.EVENT_ID.KEY, 'in', chunkIds),
      ])
    )

    const results = await Promise.all(snapPromises)

    results.forEach((snap) => {
      snap.docs.forEach((doc) => {
        const data = getConvertedData(RegistrationByDayModel.fromFirestoreDoc(doc).toObject())
        registeredRiders.push(data)
      })
    })

    return registeredRiders.filter((rider) => !rider.isDivision)
  } catch (error) {
    console.error(error, 'error')
    return []
  }
}

export const getAllRidersByEventAndUser = async (eventId: string, userId: string) => {
  try {
    const registeredRiders: IRegistrationByDayInterface[] = []

    const registeredRidersSnaps = await FirestoreService.filterItems(
      COLLECTIONS.REGISTRATION_BY_DAY.NAME,
      [
        where(COLLECTIONS.REGISTRATION_BY_DAY.FIELDS.EVENT_ID.KEY, '==', eventId),
        where(COLLECTIONS.REGISTRATION_BY_DAY.FIELDS.USER_ID.KEY, '==', userId),
      ]
    )

    registeredRidersSnaps.docs.forEach((currDoc) => {
      const current = getConvertedData(RegistrationByDayModel.fromFirestoreDoc(currDoc).toObject())
      registeredRiders.push(current)
    })

    return registeredRiders
  } catch (error) {
    console.error(error, 'error')
    return []
  }
}

export const getAllRidersByRider = async (registrationId: string, riderId: string) => {
  try {
    const registeredRiders: IRegistrationByDayInterface[] = []

    const registeredRidersSnaps = await FirestoreService.filterItems(
      COLLECTIONS.REGISTRATION_BY_DAY.NAME,
      [
        where(COLLECTIONS.REGISTRATION_BY_DAY.FIELDS.RIDER_ID.KEY, '==', riderId),
        where(COLLECTIONS.REGISTRATION_BY_DAY.FIELDS.REGISTRATION_DOC_ID.KEY, '==', registrationId),
      ]
    )

    registeredRidersSnaps.docs.forEach((currDoc) => {
      const current = getConvertedData(RegistrationByDayModel.fromFirestoreDoc(currDoc).toObject())
      registeredRiders.push(current)
    })

    return registeredRiders
  } catch (error) {
    console.error(error, 'error')
    return []
  }
}

export const getByRegistrationId = async (registrationId: string) => {
  try {
    const registeredRiders: IRegistrationByDayInterface[] = []

    const registeredRidersSnaps = await FirestoreService.filterItems(
      COLLECTIONS.REGISTRATION_BY_DAY.NAME,
      [where(COLLECTIONS.REGISTRATION_BY_DAY.FIELDS.REGISTRATION_DOC_ID.KEY, '==', registrationId)]
    )

    registeredRidersSnaps.docs.forEach((currDoc) => {
      const current = getConvertedData(RegistrationByDayModel.fromFirestoreDoc(currDoc).toObject())
      registeredRiders.push(current)
    })

    return registeredRiders
  } catch (error) {
    console.error(error, 'error')
    return []
  }
}

const RegistrationDyDayService = {
  getById,
  getByEventIds,
  getAllRidersByEventAndUser,
  getByRegistrationId,
  getAllRidersByRider,
}

export default RegistrationDyDayService
